export enum AccountConfigFlags {
    DigitalScheduleBeta = 'digitalScheduleBeta',
    VolksUptime = 'volksUptime',
    PresentationAccountIds = 'presentationAccountIds',
}
